import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { ResourceTypeIcon } from 'src/components/ResourceTypeIcon';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';

import { OPTION_ADD_RESOURCE_ID } from '../../const';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  option: PropTypes.shape({
    id: PropTypes.string,
    contentType: PropTypes.oneOf(Object.values(RESOURCE_CONTENT_TYPE)),
    name: PropTypes.string,
    file: PropTypes.shape({
      fileType: PropTypes.string,
    }),
    tags: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};
const defaultProps = {
  className: '',
  classes: {},
};

export const ResourceMenuItem = ({ className, classes, option }) => {
  const styles = useStyles({ classes });

  const visibleTags = option?.tags?.slice(0, 4);
  const remainingTagCount = option?.tags?.length - visibleTags?.length;

  return (
    <div className={cx(styles.root, className)}>
      <ResourceTypeIcon
        className={styles.icon}
        type={option?.contentType}
        fileType={option.file?.fileType}
        small
      />

      <div>
        <CustomTypography
          className={styles.name}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          {option?.name}
        </CustomTypography>

        {option?.id !== OPTION_ADD_RESOURCE_ID && (
          <div className={styles.tags}>
            {visibleTags?.map((tag, index) => (
              <CustomTypography
                className={styles.tag}
                key={index}
                variant={TYPOGRAPHY_VARIANT.regular12}
              >
                {tag}
                {index < visibleTags.length - 1 && <span>, </span>}
              </CustomTypography>
            ))}
            {remainingTagCount > 0 && (
              <CustomTypography
                variant={TYPOGRAPHY_VARIANT.regular12}
                className={styles.menuItemTag}
              >
                +{remainingTagCount} more
              </CustomTypography>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
ResourceMenuItem.displayName = 'ResourceMenuItem';
ResourceMenuItem.propTypes = propTypes;
ResourceMenuItem.defaultProps = defaultProps;
